var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 200,
    viewBox: "0 0 219 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.261 200C173.489 200 218.261 155.228 218.261 100C218.261 44.7715 173.489 0 118.261 0C63.0323 0 18.2607 44.7715 18.2607 100C18.2607 155.228 63.0323 200 118.261 200Z",
    fill: "#C1E8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.385 85.8872L121.286 106.242L147.406 111.146L148.505 87.231L135.143 73.3159L122.385 85.8872Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7507 116.568L25.9456 117.749V166.463L30.7507 165.282V116.568Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9455 166.463L21.1345 165.282V116.568L25.9455 117.749V166.463Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.879 56.2769C101.879 56.2769 104.828 71.8965 110.198 84.1245C112.094 88.441 117.01 88.9529 118.505 88.918C123.188 88.8016 128.057 87.0681 135.579 76.847L133.031 67.324C133.031 67.324 135.306 65.1542 135.951 63.3043C136.603 61.4543 136.132 59.0634 135.073 58.5399C133.345 57.6847 131.885 58.8598 131.187 61.53L129.82 56.9808C128.825 53.6766 129.069 53.0134 126.004 51.4311L114.607 41.5998L101.873 56.2653",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.879 56.2769C101.879 56.2769 104.828 71.8965 110.198 84.1245C112.094 88.441 117.01 88.9529 118.505 88.918C123.188 88.8016 128.057 87.0681 135.579 76.847L133.031 67.324C133.031 67.324 135.306 65.1542 135.951 63.3043C136.603 61.4543 136.132 59.0634 135.073 58.5399C133.345 57.6847 131.885 58.8598 131.187 61.53L129.82 56.9808C128.825 53.6766 129.069 53.0134 126.004 51.4311L114.607 41.5998L101.873 56.2653",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.616 82.6702C118.046 81.8383 118.174 80.7156 118.901 80.1629C119.628 79.6161 120.681 79.8488 121.251 80.6807C121.821 81.5126 121.693 82.6353 120.966 83.1821C120.239 83.729 119.186 83.4963 118.616 82.6644V82.6702Z",
    fill: "#1F2025"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.018 74.555L117.109 75.509C116.551 75.6952 115.946 75.3985 115.754 74.84C114.974 72.5654 113.828 68.1501 112.339 62.5305",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.51 63.7929C116.51 63.1879 116.993 62.6876 117.603 62.6876C118.208 62.6876 118.703 63.1705 118.709 63.7813C118.715 64.3921 118.226 64.8808 117.615 64.8866C117.004 64.8924 116.516 64.4037 116.51 63.7929Z",
    fill: "#1F2025"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.522 66.3234C107.522 65.7184 108.005 65.2239 108.616 65.2181C109.226 65.2123 109.715 65.701 109.721 66.3118C109.727 66.9226 109.238 67.4171 108.627 67.4171C108.016 67.4171 107.522 66.9342 107.522 66.3234Z",
    fill: "#1F2025"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 48.3886C109.971 48.3886 117.359 56.6841 131.205 61.5416C131.205 61.5416 131.571 60.1163 132.042 59.5288C132.513 58.9412 133.078 58.1559 133.904 58.2781C134.73 58.4002 135.818 58.4642 136.103 60.1396C136.388 61.815 136.248 62.897 135.44 64.3979C134.631 65.8988 133.043 67.3298 133.043 67.3298L135.591 76.8528C135.591 76.8528 141.751 92.5073 144.375 97.6381C152.176 112.885 156.394 117.411 156.394 117.411C156.394 117.411 161.542 116.847 164.113 115.753C176.452 110.5 183.595 96.9401 183.595 96.9401C183.595 96.9401 160.943 87.3938 151.943 74.3106C142.705 60.8842 143.229 46.7365 134.439 39.6975C126.44 33.2926 109.675 30.6573 100.681 42.0826C91.6874 53.5078 91.2511 62.1 94.1365 74.8167C97.0219 87.5334 104.061 103.572 104.131 106.486C104.2 109.401 122.729 104.648 122.729 104.648L124.404 87.5625C124.404 87.5625 120.925 90.2269 114.957 88.3246C109.96 86.7365 109.07 81.5067 107.918 78.342C106.766 75.1774 104.602 69.0925 103.444 63.8801C103.444 63.8801 108.057 59.616 109.983 48.3944L109.971 48.3886Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.92 68.7493C133.737 68.7493 134.398 68.0877 134.398 67.2717C134.398 66.4556 133.737 65.7941 132.92 65.7941C132.104 65.7941 131.443 66.4556 131.443 67.2717C131.443 68.0877 132.104 68.7493 132.92 68.7493Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.206 99.2961C123.206 99.2961 108.406 99.459 105.23 104.095C102.054 108.732 98.7787 133.223 96.7833 145.079C93.3744 165.288 100.018 157.993 100.018 157.993L147.557 157.563L159.611 151.827L156.114 136.754L174.48 132.583C174.48 132.583 168.325 108.051 167.638 106.51C166.952 104.968 165.149 100.861 160.344 100.419C157.505 100.157 145.154 98.3596 145.154 98.3596C145.154 98.3596 144.014 103.066 138.697 104.887C132.857 106.888 125.975 106.597 123.206 99.302V99.2961Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M172.321 133.188C172.321 133.188 175.527 150.111 175.527 152.606C175.527 155.102 176.062 167.219 157.888 168.464C139.721 169.709 104.037 162.531 95.8465 160.925C87.6499 159.319 69.2322 156.539 67.0391 147.085C67.0391 147.085 74.0897 151.379 78.5399 151.059C82.9902 150.739 87.7604 151.379 89.2438 142.897C89.2438 142.897 90.2386 141.53 91.3613 142.152C92.4841 142.775 92.7401 142.775 92.583 146.492C92.4259 150.209 94.4387 151.163 95.3928 151.268C96.3468 151.373 157.068 153.496 158.237 152.117C159.401 150.739 156.12 136.754 156.12 136.754C156.12 136.754 165.957 134.287 172.327 133.188H172.321Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2928 75.0436C6.35856 75.0436 0.739014 82.2164 0.739014 91.0588C0.739014 91.2856 0.744831 101.309 0.750648 101.53V119.267L44.1363 130.721L59.7152 84.0314L13.287 75.0436H13.2928Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2324 99.5753C69.2324 90.7271 63.6128 83.5602 56.6786 83.5602C49.7443 83.5602 44.1248 90.7329 44.1248 99.5753C44.1248 99.8022 44.1306 100.023 44.1364 100.25V130.721L69.2207 122.717V100.244C69.2266 100.023 69.2324 99.7963 69.2324 99.5695V99.5753Z",
    fill: "#C1E8FF",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3916 104.299C53.3916 104.299 71.6115 104.642 75.0089 90.8203C77.5568 80.4538 72.6063 79.3717 69.8663 80.6865C68.4236 81.3787 68.2084 83.8685 68.3538 84.4619C69.3893 88.6329 75.1834 90.1804 80.1863 83.5253C85.9047 75.9221 81.9257 58.3595 66.8995 55.3752C48.1793 51.658 53.3509 44.4794 54.9391 42.3328",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8937 30.5468L64.5784 30.9948",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1828 27.8185L63.5952 29.9825",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4668 33.2053C63.3045 33.4962 64.6948 36.9866 64.1131 39.0692C63.5314 41.1518 62.0014 42.2455 60.5645 41.8441C59.1276 41.4427 58.3539 39.7149 58.9648 37.6381C59.6628 35.253 61.7571 32.9494 62.4668 33.1995V33.2053Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7338 32.4898C61.6872 33.374 59.0636 35.1949 56.8996 35.224C54.7355 35.253 53.2579 34.0896 53.2347 32.5945C53.2114 31.0995 54.6541 29.8778 56.8181 29.8778C59.3021 29.8778 61.7745 31.7394 61.7338 32.4898Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2166 32.6236C62.8682 33.4613 61.6349 36.0093 60.3783 37.2775C59.1218 38.5457 57.5802 38.7202 56.7018 37.8534C55.8234 36.9866 55.963 35.4334 57.237 34.1769C58.6971 32.74 61.5651 31.7859 62.2166 32.6236Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1008 33.3392C63.965 33.3392 64.6656 32.6386 64.6656 31.7743C64.6656 30.9101 63.965 30.2095 63.1008 30.2095C62.2365 30.2095 61.5359 30.9101 61.5359 31.7743C61.5359 32.6386 62.2365 33.3392 63.1008 33.3392Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8869 133.839L69.2208 122.717L44.2644 130.686L64.0724 146.428C69.692 152.158 82.1469 153.746 87.3825 148.65C92.1934 143.973 90.518 138.185 84.8869 133.834V133.839Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.0f3e9c8b21176fcfc4b12205bda2f604.svg";
export { ForwardRef as ReactComponent };